import DialogShell from "./DialogShell";

export type RecurrenceScope = "series" | "occurrence";

interface Props {
  title: string;
  onChoose: (scope: RecurrenceScope) => void;
  onCancel: () => void;
}

/**
 * 繰り返し予定のどの回を編集・削除するかを最初に聞く(Google カレンダーなどと同じ流れ)。
 * ここで決めた scope を、後続の予定シートでの保存・削除の両方に使い回す
 * (→ Schedule.tsx の openEditOccurrence)。
 */
export default function RecurrenceScopeDialog({ title, onChoose, onCancel }: Props) {
  return (
    <DialogShell onBackdropClick={onCancel}>
      <p className="text-sm text-[var(--color-ink)]">
        「{title}」は繰り返しの予定です。どの回に反映しますか?
      </p>
      <div className="flex flex-col gap-2">
        <button
          type="button"
          autoFocus
          onClick={() => {
            onChoose("occurrence");
          }}
          className="rounded-lg border-[1.5px] border-[var(--color-line)] py-2.5 text-sm font-semibold"
        >
          この回だけ
        </button>
        <button
          type="button"
          onClick={() => {
            onChoose("series");
          }}
          className="rounded-lg bg-[var(--color-teal)] py-2.5 text-sm font-semibold text-white"
        >
          すべての回
        </button>
      </div>
      <button
        type="button"
        onClick={onCancel}
        className="text-center text-[12.5px] text-[var(--color-sub)]"
      >
        キャンセル
      </button>
    </DialogShell>
  );
}
